"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var BlSwitch_1 = __importDefault(require("../../../FormComponents/BlSwitch"));
var react_i18next_1 = require("react-i18next");
var styles_module_scss_1 = __importDefault(require("../styles.module.scss"));
var ActivationSwitch = function (_a) {
    var id = _a.id, active = _a.active, activationLoading = _a.activationLoading, activatePost = _a.activatePost, handleOpenDeactivationModal = _a.handleOpenDeactivationModal;
    var t = react_i18next_1.useTranslation('common').t;
    var toggleActivation = function () {
        if (handleOpenDeactivationModal && activatePost) {
            active ? handleOpenDeactivationModal(id) : activatePost(id);
        }
    };
    return (react_1.default.createElement("li", null,
        react_1.default.createElement("label", { htmlFor: id, onClick: function (e) {
                e.preventDefault();
                e.stopPropagation();
            } },
            react_1.default.createElement("span", { className: styles_module_scss_1.default.post_status }, t(active
                ? 'MY_ANNOUNCEMENTS.STATUS.ACTIVE'
                : 'MY_ANNOUNCEMENTS.STATUS.INACTIVE')),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.switch },
                react_1.default.createElement(BlSwitch_1.default, { id: id, toggle: true, disabled: activationLoading, name: id, checked: active, onClick: function () { return toggleActivation(); } })))));
};
exports.default = ActivationSwitch;
